<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商家名称')" prop="merchantName">
                <a-input v-model="queryParam.merchantName" :maxLength="32" :placeholder="$t('请输入')+$t('商家名称')" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('经营类型')" prop="businessType">
                <a-select :placeholder="$t('请选择')+$t('经营类型')" v-model="queryParam.businessType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.BusinessTypeEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商家状态')" prop="merchantStatus">
                <a-select :placeholder="$t('请选择')+$t('商家状态')" v-model="queryParam.merchantStatus" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.MerchantStatusEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('主营行业')" prop="industryId">
                <a-select v-model="queryParam.industryId" :placeholder="$t('请选择')+$t('主营行业')" >
                  <a-select-option v-for="(item, index) in industryList" :value="item.id" :key="index">
                    {{ item.categoryName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商家类型')" prop="merchantType">
                <a-select :placeholder="$t('请选择')+$t('商家类型')" v-model="queryParam.merchantType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.MerchantTypeEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('客服电话')" prop="customerServiceMobile">
                <a-input v-model="queryParam.customerServiceMobile" :maxLength="32" :placeholder="$t('请输入')+$t('客服电话')" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md=" 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:merchantmerchant:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['merchant:merchantmerchant:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['merchant:merchantmerchant:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList"/>
      <rate-form ref="rateForm" @ok="getList"/>
      <rank-form ref="rankForm" @ok="getList"/>
      <wang-dian-form ref="wangDianForm" @ok="getList"/>

      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="merchantLogo" slot-scope="text, record">
          <div>
            <img v-if="record.merchantLogo" :src="record.merchantLogo" style="width:50px;height:50px;" @click="handleRecordPreview(record.merchantLogo)" alt="none"/>
          </div>
        </template>
        <span slot="businessType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.BusinessTypeEnum" :value="record.businessType"/>
        </span>
        <span slot="isRecommend" slot-scope="text, record">
          <a-switch :disabled="userInfo.deptType===2" @change="(checked) => onStatusChange(checked,record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isRecommend"/>
        </span>
        <span slot="merchantStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.MerchantStatusEnum" :value="record.merchantStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-button size="small" type="link" @click="jumpChinaums(record, undefined)">
             <a-icon type="ordered-list" />{{$t('商户进件')}}
          </a-button>
          <!--<a-button size="small" type="link" @click="jumpAlipay(record, undefined)" v-if="false">
             <a-icon type="ordered-list" />{{$t('支付宝进件')}}
          </a-button>
          <a-button size="small" type="link" @click="jumpWeixin(record, undefined)" v-if="false">
             <a-icon type="ordered-list" />{{$t('微信进件')}}
          </a-button>
          <a-button size="small" type="link" @click="showQrCode(record)">
             <a-icon type="qrcode" />{{$t('二维码')}}
          </a-button>
          <a-button size="small" type="link" @click="handleKickout(record)" v-hasPermi="['merchant:merchantmerchant:status']">
             <a-icon type="disconnect" />{{$t('踢下线')}}
          </a-button>
          <a-button size="small" type="link" @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:merchantmerchant:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a-button>
          <a-button size="small" type="link" @click="$refs.wangDianForm.handleConfig(record)" v-if="record.id !== '0' && record.id !== '102' ">
             <a-icon type="setting" />{{$t('旺店通配置')}}
          </a-button>
          <a-button size="small" type="link" @click="jumpDisSetting(record)" v-if="record.id !== '0' && record.id !== '102' ">
             <a-icon type="apartment" />{{$t('分销设置')}}
          </a-button>
          <a-button size="small" type="link" @click="jumpCommission(record)" v-if="record.id !== '0' && record.id !== '102' ">
             <a-icon type="pay-circle" />{{$t('佣金设置')}}
          </a-button>
          <a-button size="small" type="link" @click="$refs.rateForm.handleAudit(record)" v-hasPermi="['merchant:merchantmerchant:platRate']">
             <a-icon type="edit" />{{$t('费率')}}
          </a-button>
          <a-button size="small" type="link" @click="handleSettle(record)" v-hasPermi="['merchant:merchantmerchant:settle']">
             <a-icon type="transaction" />{{$t('结算')}}
          </a-button>-->
          <a-button size="small" type="link" @click="handleOn(record)" v-if="record.merchantStatus === 0 " v-hasPermi="['merchant:merchantmerchant:status']">
             <a-icon type="edit" />{{$t('上架')}}
          </a-button>
          <a-button size="small" type="link" @click="handleOff(record)"  v-if="record.merchantStatus === 1 && record.id !== '0' && record.id !== '102' " v-hasPermi="['merchant:merchantmerchant:status']">
             <a-icon type="edit" />{{$t('下架')}}
          </a-button>
          <a-button size="small" type="link" @click="$refs.rankForm.handleAudit(record)" v-hasPermi="['merchant:merchantmerchant:status']">
             <a-icon type="stock" />{{$t('排名')}}
          </a-button>
          <a-button size="small" type="link" @click="handleDelete(record)" v-hasPermi="['merchant:merchantmerchant:remove']" v-if="record.id !== '0' && record.id !== '102' ">
            <a-icon type="delete" />{{$t('删除')}}
          </a-button>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <a-modal :title="$t('商家二维码')" :visible="qrImageVisible" :footer="null" @cancel="qrImageCancel">
      <div class="merchant-qrcode-wrap">
        <a-spin :spinning="qrImageLoading">
          <img v-if="qrImageUrl" :src="qrImageUrl" class="merchant-qrcode-img" alt="qrcode"/>
        </a-spin>
      </div>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import {
  pageMerchantMerchant,
  listMerchantMerchant,
  delMerchantMerchant,
  merchantStatus, merchantKickout, getMerchantQrcode
} from '@/api/merchant/merchantMerchant'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import RateForm from './modules/RateForm'
import RankForm from './modules/RankForm'
import WangDianForm from './modules/WangDianForm'
import { tableMixin } from '@/store/table-mixin'
import {listIndustry} from "@/api/merchant/industry";
import {receiptSell} from "@/api/order/sell";
import {merchantSettle} from "@/api/merchant/merchantAccountBill";
import {downLoadExcel} from "@/utils/excelDownload";
import {updateVisible} from "@/api/goods/category";

export default {
  name: 'MerchantMerchant',
  components: {
    CustomDictTag,
    CreateForm,
    RateForm,
    RankForm,
    WangDianForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      industryList:[],
      industrySelected:[],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      qrImageVisible: false,
      qrImageUrl: '',
      qrImageLoading: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantName: undefined,
        merchantLogo: undefined,
        merchantBackground: undefined,
        merchantAreax: undefined,
        merchantAddress: undefined,
        merchantStatus: undefined,
        merchantDescription: undefined,
        businessType: undefined,
        longitude: undefined,
        latitude: undefined,
        marginAmount: undefined,
        industryId: undefined,
        timeOfEntry: undefined,
        customerServiceMobile: undefined,
        imgDetail: undefined,
        sortField: 'merchantRank',
        sortOrder: 'DESC',
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商家名称'),
          dataIndex: 'merchantName',
          align: 'center'
        },
        {
          title: this.$t('商家logo'),
          dataIndex: 'merchantLogo',
          scopedSlots: { customRender: 'merchantLogo' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商家所在地'),
          dataIndex: 'merchantAreaxName',
          align: 'center'
        },
        {
          title: this.$t('商家状态'),
          dataIndex: 'merchantStatus',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'merchantStatus' },
          align: 'center'
        },

        {
          title: this.$t('开店套餐'),
          dataIndex: 'merchantLevelName',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否推荐'),
          dataIndex: 'isRecommend',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'isRecommend' },
          align: 'center'
        },
        {
          title: this.$t('保证金'),
          dataIndex: 'marginAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('余额'),
          dataIndex: 'balanceAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('主营行业'),
          dataIndex: 'industryName',
          align: 'center'
        },
        {
          title: this.$t('入驻时长'),
          dataIndex: 'timeOfEntryName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('排名'),
          dataIndex: 'merchantRank',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '210px',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getIndustryList()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict','userInfo'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    jumpLakala(record) {
      this.$router.push({
        path: 'apply/lakala',
        query: {
          merchantId: record.id,
          //merchantType: record.merchantType
          //这个项目只能用企业身份(有营业执照的) 进行进件, 因为客户跟拉卡拉立项签约时就固定了 只能用营业执照进件,所以merchantType 固定传1
          merchantType: 1
        }
      })
    },
    jumpChinaums(record) {
      this.$router.push({
        path: 'apply/chinaums',
        query: {
          merchantId: record.id,
          //merchantType: record.merchantType
          //这个项目只能用企业身份(有营业执照的) 进行进件, 因为客户跟拉卡拉立项签约时就固定了 只能用营业执照进件,所以merchantType 固定传1
          merchantType: 1
        }
      })
    },
    jumpAlipay(record) {
      this.$router.push({
        path: 'apply/alipay',
        query: {
          merchantId: record.id,
          merchantType: record.merchantType
        }
      })
    },
    jumpWeixin(record) {
      this.$router.push({
        path: 'apply/weixin',
        query: {
          merchantId: record.id,
          merchantType: record.merchantType
        }
      })
    },
    jumpCommission(record) {
      this.$router.push({
        path: '/agent/agent/index',
        query: {
          merchantId: record.id
        }
      })
    },
    jumpDisSetting(record) {
      this.$router.push({
        path: '/agent/disSetting',
        query: {
          merchantId: record.id
        }
      })
    },
    onIndustryChange(value, selectedOptions) {
      this.queryParam.industryId = value[1]
      console.log('onIndustryChange',this.queryParam.industryId)

    },
    getIndustryList() {
      listIndustry({}).then(response => {
        this.industryList = response.data
      })
    },
    /** 查询商家列表 */
    getList () {
      this.loading = true
      pageMerchantMerchant(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    showQrCode(record) {
      this.qrImageUrl = ''
      this.qrImageVisible = true
      this.qrImageLoading = true
      getMerchantQrcode({ id: record.id }).then(response => {
        let base64 = ''
        if (response && response.data) {
          base64 = response.data
        } else if (response) {
          base64 = response
        }
        if (!base64) {
          this.$message.warning(this.$t('未获取到二维码'))
          return
        }
        this.qrImageUrl = base64.indexOf('data:image') === 0 ? base64 : `data:image/png;base64,${base64}`
      }).catch(() => {
        this.$message.error(this.$t('获取商家二维码失败'))
      }).finally(() => {
        this.qrImageLoading = false
      })
    },
    qrImageCancel() {
      this.qrImageVisible = false
      this.qrImageUrl = ''
      this.qrImageLoading = false
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantName: undefined,
        merchantLogo: undefined,
        merchantBackground: undefined,
        merchantAreax: undefined,
        merchantAddress: undefined,
        merchantStatus: undefined,
        merchantDescription: undefined,
        businessType: undefined,
        longitude: undefined,
        latitude: undefined,
        marginAmount: undefined,
        industryId: undefined,
        timeOfEntry: undefined,
        customerServiceMobile: undefined,
        imgDetail: undefined,
        sortField: 'merchantRank',
        sortOrder: 'DESC',
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delMerchantMerchant(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleSettle(record) {
      var that = this
      this.$confirm({
        title: this.$t('是否确认结算'),
        onOk () {
          return merchantSettle({id:record.id}).then(() => {
            that.onSelectChange([], [])
            const message = '结算成功'
            that.$message.success(message, 3)
          })
        },
        onCancel () {}
      })
    },
    onStatusChange(checked, record) {
      let data = {id:record.id, isRecommend: checked}
      merchantStatus(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('修改成功'),
            3
          );
          this.$emit('ok')
          record.isRecommend=checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handleKickout(record) {
      var that = this
      this.$confirm({
        title: this.$t('是否踢下线?'),
        onOk () {
          return merchantKickout({id:record.id}).then(() => {
            that.onSelectChange([], [])
            const message = '下线成功'
            that.$message.success(message, 3)
            that.getList()
          })
        },
        onCancel () {}
      })
    },
    handleOn(record) {
      var that = this
      this.$confirm({
        title: this.$t('是否确认上架'),
        onOk () {
          return merchantStatus({id:record.id,merchantStatus: 1}).then(() => {
            that.onSelectChange([], [])
            const message = '上架成功'
            that.$message.success(message, 3)
            that.getList()
          })
        },
        onCancel () {}
      })
    },
    handleOff(record) {
      var that = this
      this.$confirm({
        title: this.$t('是否确认下架'),
        onOk () {
          return merchantStatus({id:record.id,merchantStatus: 0}).then(() => {
            that.onSelectChange([], [])
            const message = '下架成功'
            that.$message.success(message, 3)
            that.getList()

          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          downLoadExcel('merchant/merchant/export' ,  that.queryParam)
        },
        onCancel () {}
      })
    }
  }
}
</script>
<style scoped>
.merchant-qrcode-wrap {
  text-align: center;
  min-height: 280px;
  padding: 16px 0;
}
.merchant-qrcode-img {
  width: 280px;
  height: 280px;
}
</style>
